module.exports = __webpack_public_path__ + "static/img/style_icons.4500b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/demo-blog/style_icons.jpg
// module id = /G1J
// module chunks = 0